var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4684 1.03772L12.5023 0.911719H12.3719H5.61219H5.48171L5.51563 1.03772L6.52185 4.77509C5.44177 5.85838 3.99356 7.43835 2.80904 9.19253C1.61152 10.966 0.673437 12.9319 0.673437 14.7498C0.673437 16.7363 1.45228 18.3289 2.8891 19.422C4.32247 20.5125 6.40111 21.0989 8.99202 21.0989C11.5829 21.0989 13.6616 20.5124 15.0949 19.422C16.5317 18.3288 17.3106 16.7363 17.3106 14.7498C17.3106 12.8395 16.5956 11.0758 15.5038 9.42142C14.4226 7.78289 12.9681 6.24599 11.4624 4.77428L12.4684 1.03772ZM7.293 3.99977L6.69211 1.84118H11.2932L10.7147 3.99977H7.293ZM8.99201 20.1695C7.8661 20.1695 6.0118 20.0358 4.44247 19.2886C3.65914 18.9157 2.95021 18.3915 2.43701 17.6579C1.92442 16.9252 1.60288 15.9775 1.60288 14.7499C1.60288 13.5128 2.1693 11.9757 3.22301 10.28C4.26999 8.59524 5.79197 6.76365 7.69499 4.92923H10.2894C11.8471 6.41565 13.3668 7.95691 14.4995 9.58228C15.6389 11.2174 16.3812 12.9299 16.3812 14.7499C16.3812 15.9775 16.0597 16.9252 15.5471 17.6579C15.0339 18.3915 14.325 18.9157 13.5417 19.2886C11.9723 20.0358 10.1181 20.1695 8.9921 20.1695H8.99201Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5C7 15.3305 7.5937 16 8.33133 16H9.83658C10.4783 16 11 15.4142 11 14.6931C11 13.9077 10.6822 13.6309 10.2084 13.4506L7.7916 12.5494C7.31784 12.3691 7 12.0923 7 11.3069C7 10.5858 7.52174 10 8.16342 10H9.66867C10.4063 10 11 10.6695 11 11.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9V17",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu2);
export default __webpack_public_path__ + "static/media/Menu2.daed1806d66052b1812ed502cdef8c62.svg";
export { ForwardRef as ReactComponent };